import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const DetailWrapper = styled.div`
    flex-direction: column;
    flex-wrap: nowrap;
    width: 100%;
`;

export const DetailRow = styled.div`
    flex-wrap: nowrap;

    &:not(:last-child) {
        margin-bottom: 4px;
    }
`;

export const PaymentInfo = styled.p`
    ${FONTS.S};
    color: ${COLORS.TextSecondary};
    display: flex;

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.XS};

        &:last-child {
            margin-left: auto;
        }
    }
`;

export const Separator = styled.div`
    flex: 1 1 auto;
    margin: 0 8px;
    border-bottom: 1px dashed ${COLORS.BgSecondary};

    @media (max-width: ${wideBreakpoints.mobile}) {
        display: none;
    }
`;

export const IconWrap = styled.div`
    padding: 4px;
    cursor: pointer;

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 2px;
    }
`;
